import { getParentsUntil, getAbsoluteHeight } from './utilities.js';

//MOBILE MENU TOGGLE
var show = function (elem) {
    // Get the natural height of the element
	var getHeight = function () {
		elem.style.display = 'block'; // Make it visible
		var height = elem.scrollHeight + 'px'; // Get it's height
		return height;
	};
	var headerHeight = getAbsoluteHeight( document.querySelector('header') );
    var windowHeight = window.innerHeight;
	elem.classList.add('is-visible'); // Make the element visible
    elem.style.height = (windowHeight - headerHeight) + 'px'; // Update the max-height
    var headerContainer = document.querySelector('header');
    headerContainer.classList.add('mobile-menu-open');
	// Once the transition is complete, remove the inline max-height so the content can scale responsively
};

// Hide an element
var hide = function (elem) {
	// Give the element a height to change from
    elem.style.height = elem.scrollHeight + 'px';
	// Set the height back to 0
	window.setTimeout(function () {
		elem.style.height = '0';
	}, 1);
	// When the transition is complete, hide it
	window.setTimeout(function () {
        elem.classList.remove('is-visible');
        var headerContainer = document.querySelector('header');
        headerContainer.classList.remove('mobile-menu-open');
	}, 350);
};

// Toggle element visibility
export default function toggle(elem, timing) {
	// If the element is visible, hide it
	if (elem.classList.contains('is-visible')) {
		hide(elem);
		return;
	}
	// Otherwise, show it
	show(elem);
};


//END MOBILE MENU TOGGLE